<template>
  <div class="eesa-error-main">
    <div class="eesa-error-inner">
      <div class="eesa-error-img">
        <img :src="errorImg" alt="404 Not Found" />
      </div>
      <div class="eesa-error-content">
        <h1>404</h1>
        <b>Not Found</b>
        <p>The page you requested couldn't found.</p>
        <RouterLink to="/">
          <button>Go to Home</button>
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script setup>
import errorImg from '@/assets/images/404.png'
import { RouterLink } from 'vue-router'
</script>